import { useEffect, useState } from "react";
import axios from "axios";

import { accountService } from "@/services/account";
import { ProviderProfile } from "@/types/user";

export const useProviderProfile: (
  isProvider: boolean
) => [ProviderProfile | undefined, boolean, string] = (isProvider) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [providerProfile, setProviderProfile] = useState<ProviderProfile>();

  useEffect(() => {
    const fetchProviderProfileInfo = async () => {
      try {
        const response = await accountService.getProviderProfile();
        setProviderProfile(response.data as ProviderProfile);
        setLoading(false);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          setError(error.message);
        }
        setLoading(false);
      }
    };

    if (isProvider) fetchProviderProfileInfo();
  }, [isProvider]);

  return [providerProfile, loading, error];
};
